
import { useTranslation } from 'react-i18next';
import Days from '../../data/days.json';
import '../../style/components/schdule.css';
export default function Schudle (props) {
    const { t } = useTranslation();
    return (
        <table className='scudle'>
            <thead>
                <tr>
                    <th>{t("common:day")}</th>
                    <th>{t("common:from")}</th>
                    <th>{t("common:to")}</th>
                </tr>
            </thead>
            <tbody>
                {Days.map((e, i) => 
                    <tr key={i} className={props.work.holiday.includes(String(e.name)) ? "disable" : ""}>
                        <td>{t(`days:${e.title}`)}</td>
                        <td>{(props.work.holiday).includes(e.name) ? "off" : props.work.shiftDates.start}</td>
                        <td>{(props.work.holiday).includes(e.name) ? "off" : props.work.shiftDates.end}</td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}